import CompartmentDetails from './CompartmentDetails';

export default CompartmentDetails;
